<div class="modal active">
  <div class="modal__container modal__container--lg" style="top: 5%;">
      <div class="fields">
          <h2>Potential Duplications Found</h2>
          <div class="close" (click)="bsModalRef.hide();"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
              <div class="fields__block">
                <div class="fields__block__section">
                  <div class="table-fields">
                    <h4> The following imported Coordinate points are potential duplications. Please check the working log file for more information. </h4>
                    <div class="table_container" style="height: 550px; overflow-y:auto;">
                        <table>
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Published</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let coord_point of duplicates; let i = index">
                                <td>{{coord_point.coordpointid}}</td>
                                <td>{{coord_point.name}}</td>
                                <td>{{coord_point.type}}</td>
                                <td>{{coord_point.published}}</td>
                                <td>{{coord_point.latitude}}</td>
                                <td>{{coord_point.longitude}}</td>
                              </tr>
                            </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fields__btn">
                <button (click)="bsModalRef.hide();" class="blue">Ok</button>
                <button (click)="exportCoordinatePointsToCsv();" class="blue" >Export</button>
              </div>
            </div>
      </div>
    </div>
</div>
